import {
    Table,
    TableBody,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { useContext, useEffect, useState } from "react";
import { StatusContext } from "../Context/StatusContext";
import { AppRow } from "./AppRow";

const WsUrl = import.meta.env.VITE_DEPLOYER_WS;

interface AddTags {
    key: string
    value: string
}

export interface IAppsData {
    id: number;
    name: string;
    status: number;
    method: number;
    author: string;
    dbName: string;
    branchBase: string;
    creationDate: Date;
    changeDate: Date;
    error: string;
    addtags: AddTags[]
}

export const AppsTable = () => {
    const [data, setData] = useState<IAppsData[]>([]);
    const { setContextStatus } = useContext(StatusContext);

    useEffect(() => {
        function connectWs() {
            if (!WsUrl) return;

            const socket = new WebSocket(`${WsUrl}/ws`);

            socket.onopen = () => {
                console.log("WebSocket connection established.");
            };

            socket.onmessage = (event) => {
                try {
                    const jsonData = JSON.parse(event.data) || [];
                    if (Array.isArray(jsonData)) {
                        setData(jsonData);
                        const statusArray = jsonData.map((d: IAppsData) => ({
                            id: d.id,
                            status: d.status,
                        }));
                        setContextStatus(statusArray);
                    } else {
                        console.warn("Unexpected data format", jsonData);
                    }
                } catch (error) {
                    console.error("Error processing WebSocket message", error);
                }
            };

            socket.onerror = (error) => {
                console.error("WebSocket error:", error);
            };

            socket.onclose = (event) => {
                console.log("WebSocket connection closed:", event);
                connectWs()
            };

            return () => {
                socket.close();
            };
        }
        connectWs();
    }, [setContextStatus]);

    return (
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>Nome</TableHead>
                    <TableHead className="text-center">Status</TableHead>
                    <TableHead className="hidden md:table-cell text-center">
                        Método de criação
                    </TableHead>
                    <TableHead className="hidden md:table-cell text-center">
                        Autor
                    </TableHead>
                    <TableHead className="hidden md:table-cell text-center">
                        Baseado em
                    </TableHead>
                    <TableHead className="hidden md:table-cell text-center">
                        Banco de Dados
                    </TableHead>
                    <TableHead className="hidden md:table-cell text-center">
                        Tags Adicionais
                    </TableHead>
                    <TableHead className="hidden md:table-cell text-center">
                        Criado em
                    </TableHead>
                    <TableHead className="hidden md:table-cell text-center">
                        Atualizado em
                    </TableHead>
                    <TableHead>
                        <span className="sr-only">Actions</span>
                    </TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {data
                    .sort(
                        (a: IAppsData, b: IAppsData) =>
                            new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime()
                    )
                    .map((app) => (
                        <AppRow
                            key={app.id}
                            appData={app}
                        />
                    ))}
            </TableBody>
        </Table>
    );
};
